import { getLoggerInstance } from '@idmc-ms-fabric/common';
import { fabricServiceModels } from '@infa-hawk/services';

import constants from '../../../utils/constants';
import { AsyncPolling, AsyncPollingConfig, BEWLErrorResponse, FetchError, fetchWrapper } from '../../../utils/coreUtils';
import { REGISTRATION_STATUS, TRegistrationDetails } from './Registration.types';

export const getRegistration = async (config: fabricServiceModels.IGetRegistrationRequest): Promise<TRegistrationDetails> => {
	let returnValue: TRegistrationDetails;
	const logger = getLoggerInstance({});
	try {
		const response = await fetchWrapper.post<fabricServiceModels.IGetRegistrationRequest, fabricServiceModels.IGetRegistrationResponse>(
			`${constants.FABRIC_BE_SERVICE_URI}/api/v1/authentication/register`,
			config,
		);
		returnValue = { status: REGISTRATION_STATUS.COMPLETED, details: response };
	} catch (error) {
		logger.error('Getting Org Registration Details failed.');
		returnValue = { status: REGISTRATION_STATUS.FAILURE };
		try {
			if (error instanceof FetchError) {
				const details = await error.getResponseDetails<BEWLErrorResponse>();
				if (details.errorCode === 'ITAPP-FAB01') {
					logger.error('No informatica org exists for this tenant');
					returnValue = { status: REGISTRATION_STATUS.ORG_DOESNOT_EXIST, details: { registrationURL: details.debugMessage } };
				} else if (details.errorCode === 'ITAPP-FAB03') {
					returnValue = { status: REGISTRATION_STATUS.INPROGRESS };
				}
			}
		} catch (error) {
			logger.error('Something went wrong while fetching registration details', { error });
		}
	}
	return returnValue;
};

export class RegistrationStatusPolling extends AsyncPolling<TRegistrationDetails> {
	constructor(
		private workspaceId: string,
		private token: string,
		config: AsyncPollingConfig<TRegistrationDetails>,
	) {
		super(config);
	}
	async poll() {
		const resp = await getRegistration({ accessToken: this.token, workspaceId: this.workspaceId });
		return resp;
	}
}
